import { useEffect } from "react";
import Job from "./Job";
import Wrapper from "../assets/wrappers/JobsContainer";
import { useSelector, useDispatch } from "react-redux";
import Loading from "./Loading";
import { getAllJobs } from "../features/allJobs/allJobsSlice";
import PageBtnContainer from "./PageBtnContainer";

const JobsContainer = () => {
  const { jobs, isLoading, page, totalJobs, numOfPages, search, searchStatus, searchJobType, sort } = useSelector(
    (store) => store.allJobs,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    //dispatch getAllJobs thunk
    dispatch(getAllJobs());
  }, [page, search, searchStatus, searchJobType, sort, dispatch]);

  if (isLoading) {
    return <Loading center />;
  }
  if (jobs.length === 0) {
    return <Wrapper>No jobs to display...</Wrapper>;
  }
  console.log('Jobs array:', jobs);
  console.log('Jobs length:', jobs?.length);
  console.log('Total jobs:', totalJobs);
  //console.log('Redux allJobs state:', useSelector((store) => store.allJobs));

  return (
    <Wrapper>
      <h5>{totalJobs} job{jobs.length > 1 && "s"} found</h5>
      <div className="jobs">
        {jobs.map((job) => {
          return <Job key={job._id} {...job} />;
        })}
      </div>
      {numOfPages > 1 && <PageBtnContainer />}
    </Wrapper>
  );
};

export default JobsContainer;
